import React, { useEffect, useRef, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";

const delay = (ms) => new Promise((r) => setTimeout(r, ms));

function SecondaryCamera({ deviceId, style }) {
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    console.log("[SecondaryCamera] mount/update — deviceId:", deviceId);

    (async () => {
      await delay(300);
      if (cancelled) return;

      for (let attempt = 0; attempt < 3; attempt++) {
        if (cancelled) return;
        console.log("[SecondaryCamera] attempt", attempt + 1, "for", deviceId);
        try {
          const t0 = performance.now();
          const stream = await navigator.mediaDevices.getUserMedia({
            video: { deviceId: { exact: deviceId } },
            audio: false,
          });
          const elapsed = Math.round(performance.now() - t0);
          if (cancelled) {
            stream.getTracks().forEach((t) => t.stop());
            return;
          }
          const trackLabel = stream.getVideoTracks()[0]?.label || "unknown";
          console.log("[SecondaryCamera] stream acquired in", elapsed, "ms — track:", trackLabel);
          streamRef.current = stream;
          if (videoRef.current) {
            videoRef.current.srcObject = stream;
          }
          setLoading(false);
          return;
        } catch (e) {
          console.warn("[SecondaryCamera] attempt", attempt + 1, "FAILED:", e.name, e.message);
          if (attempt < 2) {
            await delay(500);
          } else {
            console.error("[SecondaryCamera] ALL 3 ATTEMPTS FAILED for", deviceId);
            setLoading(false);
          }
        }
      }
    })();

    return () => {
      console.log("[SecondaryCamera] cleanup — stopping stream for", deviceId);
      cancelled = true;
      if (streamRef.current) {
        streamRef.current.getTracks().forEach((t) => t.stop());
        streamRef.current = null;
      }
      if (videoRef.current) {
        videoRef.current.srcObject = null;
      }
    };
  }, [deviceId]);

  return (
    <>
      <video
        ref={videoRef}
        autoPlay
        playsInline
        muted
        style={style}
      />
      {loading && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0,0,0,0.45)",
          }}
        >
          <CircularProgress size={40} style={{ color: "#F37637" }} />
        </div>
      )}
    </>
  );
}

export default React.memo(SecondaryCamera);
